<template>
    <v-dialog v-model="editorShownAvailable" width="850">
        <!-- Begin:Content:Mode:update ------------------------------------- -->
        <v-card v-if="editorMode === 'update'" style="border: 2px solid pink;">
            <v-card-title class="grey pa-5" style="color: white; font-size: 15px; font-weight: 500;">
                <i style="font-size:20px; color: pink;" class="b-fa b-fa-check-circle"></i>&nbsp;&nbsp;{{ eventName || '&nbsp;' }} ({{ editorMode.toUpperCase() }})
            </v-card-title>

            <v-card-text class="pa-5">
                <datetime v-model="startDate" label="Available - from:" disabled="false" disabledTime="true" ref="startTimer" />
                <datetime v-model="endDate" label="Available  - to:" disabled="true" disabledTime="true" ref="endTimer" />

                <v-row>
                    <v-col cols="6" class="">
                        <airports-combo v-model="aptCode" label="Select Arprt:" />
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-text class="pa-5">
                <comment-textarea v-model="dutyComment" label="Available Comment:" maxlength="300" />
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="editorShownAvailable = false">Cancel</v-btn>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="onSave_AvailableUpdate"> Save</v-btn>
            </v-card-actions>
        </v-card>



        <!-- Begin:Content:Mode:create ------------------------------------- -->
        <v-card v-if="editorMode === 'create'" style="border: 2px solid pink;">
            <v-card-title class="grey pa-5" style="color: white; font-size: 15px; font-weight: 500;">
                <i style="font-size:20px; color: pink;" class="b-fa b-fa-check-circle"></i>&nbsp;&nbsp;{{ eventName || '&nbsp;' }} ({{ editorMode.toUpperCase() }})
            </v-card-title>

            <v-card-text class="pa-5">
                <datetime v-model="startDate" label="Available - from:" disabled="false" disabledTime="true" ref="startTimer" />
                <datetime v-model="endDate" label="Available  - to:" disabled="false" disabledTime="true" ref="endTimer" />

                <v-row>
                    <v-col cols="6" class="">
                        <airports-combo v-model="aptCode" label="Select Arprt:" />
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-text class="pa-5">
                <comment-textarea v-model="dutyComment" label="Available Comment:" maxlength="300" />
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="editorShownAvailable = false">Cancel</v-btn>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="onSave_AvailableCreate"> Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import Vue from 'vue';
    import Datetime from '../../DateTime.vue';
    import AirportsCombo from '../../AirportsCombo.vue';
    import CommentTextarea from '../../CommentTextarea.vue';

    import { mapGetters, mapActions } from 'vuex';
    import { eventBus } from '../../../../../../../main';
    import moment from 'moment';


    export default {
        name  : 'event-editor-available',

        /* >>> *************************************************************** / /* Props */
        props : {

            value           : [ Boolean, Object ],                              // editorShownAvailable
            eventStore      : Object,                                           // 'update'
            resourceId      : [ String, Number ],                               // 'update'
            eventRecord     : Object,                                           // 'update'
            resourceRecord  : Object,                                           // 'create'
            addDate         : Date,                                             // 'create'
            eventName       : String,                                           // 'update', 'create'
            editorMode      : String,                                           // 'update', 'create'

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components : {

            Datetime,
            AirportsCombo,
            CommentTextarea

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: () => ({

            // >>> ------------------------------
            startDate       : null,
            endDate         : null,
            // >>> ------------------------------
            idApt           : null, // gets set in: 'get_AirportId'
            aptCode         : null,
            // >>> ------------------------------
            dutyComment     : null,
            // >>> ------------------------------

        }), // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed : {

            ...mapGetters([
                'get_Airports',
                'get_shared_IsEditingInThePastAllowed',
            ]),


            /*******************************************************************
            * editorShownAvailable()
            *
            * Desc:
            * Note: Distinguishes between editorMode: 'update', 'create'
            *
            */
            editorShownAvailable: {

                /***************************************************************
                * get()
                *
                * Desc:
                * Note:
                */
                get() {

                    let me = this,
                        timestamp = null,
                        startDate = null,
                        endDate = null,
                        resourceRecord = me.resourceRecord,
                        eventRecord = me.eventRecord;


                    me.$toc('>>> views/crewplanning/crewcalendar/components/editevents/available/EventEditor.vue >>> editorShownAvailable get');
                    if (true === me.value) {                                    // we're opening so initialize data

                        // >>> ------------------ update
                        if (this.editorMode === 'update') {
                            if (eventRecord) {
                                Object.assign(me, {
                                    eventName       : this.eventName, // eventRecord.name,
                                    startDate       : new Date(eventRecord.startDate),
                                    endDate         : new Date(eventRecord.endDate),
                                    idApt           : eventRecord.idApt,
                                    aptCode         : eventRecord.aptCode,
                                    dutyComment     : eventRecord.dutyComment,
                                });
                            }
                        }

                        // >>> ------------------ create
                        if (this.editorMode === 'create') {
                            if (resourceRecord) {
                                timestamp = new Date(this.addDate).setHours(0, 0, 0, 0);
                                startDate = new Date(timestamp);
                                timestamp = new Date(this.addDate).setHours(23, 59, 0, 0);
                                endDate = new Date(timestamp);

                                Object.assign(me, {
                                    eventName       : this.eventName,
                                    startDate       : startDate,
                                    endDate         : endDate,
                                    idApt           : null,
                                    aptCode         : null,
                                    dutyComment     : null,
                                });
                            }
                        }

                    } else if (false === me.value) {                            // we're closing so fire close event
                        // this.$emit('close'); // Needed?
                    }

                    // return always Boolean
                    return !!this.value;

                }, // eo editorShownAvailable get

                /***************************************************************
                * set()
                *
                * Desc:
                * Note: only runs on close.
                */
                set(value) {

                    let me = this;;


                    me.$toc('>>> views/crewplanning/crewcalendar/components/editevents/available/EventEditor.vue >>> editorShownAvailable set');
                    this.$emit('input', value);

                } // eo editorShownAvailable set

            } // eo editorShownAvailable

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc: Listen to: 'updateavailable'.
        * Note: Runs after the instance is created. Installs Listeners.
        *
        */
		created: function () {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/available/EventEditor.vue >>> created');
            eventBus.$on('updateavailable', this.onUpdate_SingleDuty); // call: update single duty successful
            eventBus.$on('onchangedatepicker', this.onChange_DatePicker); // onChange_DatePicker (not used right now)

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/available/EventEditor.vue >>> beforeDestroy');
            eventBus.$off('updateavailable', this.onUpdate_SingleDuty);
            eventBus.$off('onchangedatepicker', this.onChange_DatePicker);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_update_SingleDuty',
                'actn_create_SingleDuty',
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners: Save Handlers
            *******************************************************************/
            /*******************************************************************
            * onSave_AvailableUpdate()
            *
            * Desc: Save Handler - 'UPDATE'.
            * Note: Tooltip is in 'note'.
            * Note: Calling this method updates also duration (resizes the event)
            * Note: Check if edit in past is allowed.
            *
            */
            onSave_AvailableUpdate: function(){

                let me = this,
                    params = {};


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/available/EventEditor.vue >>> onSave_AvailableUpdate');
                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [me.startDate], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                params = {
                    id              : me.eventRecord.originalId,
                    idResource      : me.resourceId,
                    from            : moment(me.startDate).format('YYYY-MM-DDT05:00:ss+0000'),
                    to              : moment(me.endDate).format('YYYY-MM-DDT21:00:ss+0000'),
                    type            : 'AVAILABLE',
                    status          : 'PLANNED',
                    idApt           : this.get_AirportId(me.aptCode),
                    dutyComment     : me.dutyComment !== '' ? me.dutyComment : null
                };

                this.actn_update_SingleDuty(params);

            }, // eo function onSave_AvailableUpdate()


            /*******************************************************************
            * onSave_AvailableCreate()
            *
            * Desc: Save Handler - 'UPDATE'.
            * Note: Tooltip is in 'note'.
            * Note: Check if edit in past is allowed.
            *
            */
            onSave_AvailableCreate: function() {

                let me = this,
                    params = {};


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/available/EventEditor.vue >>> onSave_AvailableCreate');
                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [me.startDate], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                params = {
                    id              : null,
                    idResource      : this.resourceRecord.id,
                    from            : moment(me.startDate).format('YYYY-MM-DDT05:00:ss+0000'),
                    to              : moment(me.endDate).format('YYYY-MM-DDT21:00:ss+0000'),
                    type            : 'AVAILABLE',
                    status          : 'PLANNED',
                    idApt           : this.get_AirportId(me.aptCode),
                    split           : true,
                    dutyComment     : me.dutyComment !== '' ? me.dutyComment : null
                };

                if (this.validateParams(params) === true) {
                    this.actn_create_SingleDuty(params);
                }

            }, // eo function onSave_AvailableCreate()



            /******************************************************************* 'Listeners - eventBus'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onUpdate_SingleDuty()
            *
            * Desc: Successful Call => emits 'updateavailable' Event.
            * Desc: Change Data in Scheduler.
            * Note: Using Response of call:actn_update_SingleDuty for buildEventNote
            * Note:
            *
            * @param {Object} response (Response from Call)
            */
            onUpdate_SingleDuty: function(response){

                let me = this,
                    style = null,
                    tooltipData = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/available/EventEditor.vue >>> onUpdate_SingleDuty');
                // >>> set --------------------------------
                me.eventRecord.setStartEndDate(me.startDate, me.endDate);
                me.eventRecord.set({ idApt: me.idApt });
                me.eventRecord.set({ aptCode: me.aptCode });
                me.eventRecord.set({ dutyComment: me.dutyComment });

                tooltipData = me.$buildEventNote(response); // Catch after 'requested was set!: Important
                me.eventRecord.set({ nameEvent: tooltipData.nameEvent });
                me.eventRecord.set({ note: tooltipData.note });


                // >>> style ------------------------------
                if (response.dutyComment !== null) {
                    style = ' border-right: 3px dotted #000;';
                }
                me.eventRecord.set({ style: style });


                if (!me.eventRecord.eventStore) {
                    me.eventStore.add(me.eventRecord);
                    me.eventRecord.resourceId = me.resourceId;
                }

                // >>> close the editor -------------------
                me.editorShownAvailable = false;

            }, // eo function onUpdate_SingleDuty()


            /*******************************************************************
            * onChange_DatePicker()
            *
            * Desc: If Start DatePicker changed, it emits an Event and its
            * Desc: new Value to set it to End DatePicker.
            *
            * @param {String} value ()
            */
            onChange_DatePicker: function(value){

                let me = this,
                    newDate = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/available/EventEditor.vue >>> onChange_DatePicker');
                newDate = new Date(value);
                newDate.setHours(23);
                newDate.setMinutes(59);
                me.endDate = newDate;

            }, // eo function onChange_DatePicker()




            /*******************************************************************
            * Validators:
            *******************************************************************/
            /*******************************************************************
            * validateParams()
            *
            * Desc:
            * Note:
            *
            * @param {Object} params (Params we want to send)
            */
            validateParams: function(params) {

                let me = this,
                    startDate = null,
                    endDate = null,
                    valid = false;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/available/EventEditor.vue >>> validateParams');
                startDate = moment(params.from);
                endDate = moment(params.to);

                if (endDate.isBefore(startDate)) {
                    valid = false;
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: 'Validation: EndDate must be after StartDate.'
                    });
                } else {
                    valid = true;
                }


                return valid;

            }, // eo function validateParams()




            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * get_AirportId()
            *
            * Desc: Return Airports ID.
            * Note:
            *
            */
            get_AirportId: function(code) {

                let me = this,
                    aptId = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/available/EventEditor.vue >>> get_AirportId');
                this.get_Airports.forEach((apt, i) => {
                    if (apt.aptCode === code) {
                        this.idApt = apt.idAirport;
                        aptId = apt.idAirport;
                    }
                });


                return aptId;

            }, // eo function get_AirportId()

        }, // eo methods{}
        /* <<< ****************************************************************/

    };
</script>
